/**
 * Component showing the error of a task in the Task List.
 *
 * Copyright © Ircam Amplify 2025-2026
 */
import { fetchTaskJobInfo } from '@/api/api'
import { useState } from 'react'
import { BiErrorCircle, BiLoaderAlt } from 'react-icons/bi'
import './JobError.css'

interface JobErrorProps {
  jobId?: string
  message?: string
}

const JobError = (props: JobErrorProps) => {
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState<string | undefined>(props.message)
  const [showError, setShowError] = useState(false)

  const onClick = async () => {
    if (!loading && message === undefined) {
      setLoading(true)
      const data = await fetchTaskJobInfo({ jobId: props.jobId })
      if (data?.report_info?.report?.errorMessage !== undefined) {
        setMessage(data?.report_info?.report?.errorMessage)
        setShowError(true)
      }
      setLoading(false)
    }
  }

  return (
    <div className="errorContainer">
      <div
        className={`errorDiv ${!loading && message === undefined ? '!cursor-pointer' : '!cursor-default'}`}
        onMouseEnter={() => message !== undefined && setShowError(true)}
        onMouseLeave={() => showError === true && setShowError(false)}
        onClick={onClick}
      >
        {loading ? (
          <BiLoaderAlt className="loadingIcon mt-[2px]" />
        ) : (
          <BiErrorCircle className="mt-[2px]" />
        )}
        Error
      </div>

      <div className={showError ? 'errorPopup showError' : 'errorPopup'}>
        {message ?? ''}
      </div>
    </div>
  )
}

export default JobError
